import { useQuery } from '@tanstack/react-query'
import { useClient } from '@/stores/useClient.ts'
import { ProfProjectTemplate } from '@/models/profProjectTemplate.ts'

export const PROJECT_TEMPLATES_QUERY_KEY = ['project-templates']

/** Shared query for the account's project templates (no pagination, sorted by name). */
export function useProjectTemplates() {
  const { getProjectTemplates } = useClient()
  return useQuery({
    queryKey: PROJECT_TEMPLATES_QUERY_KEY,
    queryFn: async () => {
      const res = await getProjectTemplates()
      return res.data as ProfProjectTemplate[]
    },
  })
}

interface ProjectTemplateSelectProps {
  value: string | null
  onChange: (templateId: string | null) => void
  disabled?: boolean
  /** Label of the empty option */
  emptyLabel?: string
  className?: string
}

export default function ProjectTemplateSelect({
  value,
  onChange,
  disabled,
  emptyLabel = 'Keine Vorlage',
  className = 'select select-bordered w-full',
}: ProjectTemplateSelectProps) {
  const { data: templates } = useProjectTemplates()

  return (
    <select
      className={className}
      value={value ?? ''}
      onChange={e => onChange(e.target.value || null)}
      disabled={disabled}
    >
      <option value="">{emptyLabel}</option>
      {templates?.map(template => (
        <option key={template.id} value={template.id}>{template.name}</option>
      ))}
    </select>
  )
}
